module.exports = __webpack_public_path__ + "img/sonargroup-contact.f4e86a27.jpg";